export default __webpack_public_path__ + "static/media/vaccine-card-example.88432619.jpg";